<template>
  <div>
    <md-app-toolbar>
      <div class="md-toolbar-row">
        <BuildingStockHeader :site-id="parseInt($route.params.siteId)" />
      </div>
    </md-app-toolbar>
    <md-app md-mode="fixed">
      <md-app-content class="page-content">
        <md-card class="spacer">
          <md-card-content>
            <div class="nav__controls">
              <div
                class="nav__item"
                @click='paginateConsumptionsPrevious()'>
                <i
                  class="material-icons"
                  v-if="hasConsumptionsPreviousPagination">
                  navigate_before
                </i>
              </div>
              <div class="result"> {{ consumptionsPaginationYear }}</div>
              <div
                class="nav__item"
                @click='paginateConsumptionsNext()'>
                <i
                  class="material-icons"
                  v-if="hasConsumptionsNextPagination">
                  navigate_next
                </i>
              </div>
            </div>
            <md-table>
              <md-table-toolbar>
                <h1 class="md-title">Détails des consommations (sans correction climatique)</h1>
              </md-table-toolbar>
              <md-table-row>
                <md-table-head class="collapse-arrow-column" />
                <md-table-head>Nom</md-table-head>
                <md-table-head>Adresse</md-table-head>
                <md-table-head/>
                <md-table-head>Commentaires</md-table-head>
                <md-table-head>Tags</md-table-head>
                <md-table-head>SU</md-table-head>
                <md-table-head
                  v-for='(energy, i) in siteEnergyList'
                  :key="`energy-${i}`">
                  Consommation {{ energy.label|toLowerCase }}
                </md-table-head>
              </md-table-row>
              <template
                v-for='building in siteBuildings'>
                <md-table-row
                  :key="`building-${building.id}`">
                  <md-table-cell
                    @click.native="handleCollapse(building, 'consumptions')"
                    class="collapse-arrow-column">
                    <template v-if="building.childs.length > 0">
                      <md-icon v-if="!building.ConsumptionsCollapsed">keyboard_arrow_down</md-icon>
                      <md-icon v-if="building.ConsumptionsCollapsed">keyboard_arrow_up</md-icon>
                    </template>
                  </md-table-cell>
                  <md-table-cell
                    @click.native="handleCollapse(building, 'consumptions')"
                    class="name-column">
                    <div><strong>{{ building.name }}</strong></div>
                    <div><em v-if='building.is_processed === false'>Non traité</em></div>
                    <div><em v-if='building.is_atypical === true'>Atypique</em></div>
                  </md-table-cell>
                  <md-table-cell
                    @click.native="handleCollapse(building, 'consumptions')">
                    <span :inner-html.prop="building.address | displayAddress" />
                  </md-table-cell>
                  <md-table-cell>
                    <a
                      :href="getGoogleMapsUrl(building.address)"
                      target="_blank"
                      class="place-coordinates">
                      <md-icon>open_in_new</md-icon>
                      <md-tooltip>Ouvrir dans Google Maps (Lat : {{ parseFloat(building.address.latitude).toString() }}, Lng : {{ parseFloat(building.address.longitude).toString() }})</md-tooltip>
                    </a>
                  </md-table-cell>
                  <md-table-cell>
                    <md-icon v-if="building.comment">
                      comment
                      <md-tooltip>{{ building.comment }}</md-tooltip>
                    </md-icon>
                  </md-table-cell>
                  <md-table-cell
                    @click.native="handleCollapse(building, 'consumptions')">
                    <TagsListWidget
                      :items="building.tags"
                      :visible-items-count=1 />
                  </md-table-cell>
                  <md-table-cell
                    @click.native="handleCollapse(building, 'consumptions')">
                    {{ getPlaceUsableArea(building) }} m²
                  </md-table-cell>
                  <md-table-cell
                    @click.native="handleCollapse(building, 'consumptions')"
                    :key="`building-${building.id}-consumption-${i}`"
                    v-for='(consumption, i) in getPlaceConsumptions(building)'>
                    <span
                      v-if="consumption">{{ consumption|formatIntNumber }} kWh</span>
                    <span
                      v-else>-</span>
                  </md-table-cell>
                </md-table-row>

                <md-table-row
                  class='md-selected'
                  :key="`area-${area.id}`"
                  v-for='area in building.childs'
                  v-if='area.visibleConsumptions === true'>
                  <md-table-cell />
                  <md-table-cell>{{ area.name }}</md-table-cell>
                  <md-table-cell />
                  <md-table-cell />
                  <md-table-cell>
                    <span
                      @click="showPlaceDetailsCommentDialog(area)"
                      v-if='area.comment'>
                      <md-icon>comment</md-icon>
                    </span>
                  </md-table-cell>
                  <md-table-cell />
                  <md-table-cell>
                    {{ getPlaceUsableArea(area) }}&nbsp;m²
                  </md-table-cell>
                  <md-table-cell
                    :key="`area-${area.id}-consumption-${i}`"
                    v-for='(consumption, i) in getPlaceConsumptions(area)'>
                    <span
                      v-if="consumption">{{ consumption|formatIntNumber }}&nbsp;kWh</span>
                    <span
                      v-else>-</span>
                  </md-table-cell>
                </md-table-row>
              </template>
              <md-table-row>
                <md-table-cell class="collapse-arrow-column" />
                <md-table-cell><strong>TOTAL</strong></md-table-cell>
                <md-table-cell/>
                <md-table-cell/>
                <md-table-cell/>
                <md-table-cell/>

                <md-table-cell>
                  <strong>{{ totalUsableArea }}&nbsp;m²</strong>
                </md-table-cell>

                <md-table-cell
                  :key="`total-consumption-${i}`"
                  v-for='(consumption, i) in totalConsumptions'>
                  <strong
                    v-if="consumption">{{ consumption|formatIntNumber }}&nbsp;kWh</strong>
                  <strong
                    v-else>-</strong>
                </md-table-cell>
              </md-table-row>
            </md-table>
          </md-card-content>
        </md-card>
        <md-card class="spacer">
          <md-card-content class="overflow__visible">
            <div class="nav__controls">
              <div
                class="nav__item"
                @click='paginateUsesPrevious()'>
                <i
                  class="material-icons"
                  v-if="hasUsesPreviousPagination">
                  navigate_before
                </i>
              </div>
              <div class="result">
                {{ usesPaginationYear }}
              </div>
              <div
                class="nav__item"
                @click='paginateUsesNext()'>
                <i
                  class="material-icons"
                  v-if="hasUsesNextPagination">
                  navigate_next
                </i>
              </div>
            </div>

            <md-table
              class="table-overflow"
            >
              <md-table-toolbar>
                <h1 class="md-title">Usages</h1>
              </md-table-toolbar>
              <md-table-row>
                <md-table-head class="collapse-arrow-column" />
                <md-table-head>Nom</md-table-head>
                <md-table-head>Fonction</md-table-head>
                <md-table-head class="legend-head">
                  Répartition par usage (corrigée du climat)
                </md-table-head>
              </md-table-row>

              <template
                v-for='building in siteBuildings'>
                <md-table-row
                  :key="`building-${building.id}`"
                  @click="handleCollapse(building, 'uses')">
                  <md-table-cell class="collapse-arrow-column">
                    <template v-if="building.childs.length > 0">
                      <md-icon v-if="!building.UsesCollapsed">keyboard_arrow_down</md-icon>
                      <md-icon v-if="building.UsesCollapsed">keyboard_arrow_up</md-icon>
                    </template>
                  </md-table-cell>
                  <md-table-cell class="name-column">
                    <strong>{{ building.name }}</strong>
                  </md-table-cell>
                  <md-table-cell>
                    {{ building.function }}
                  </md-table-cell>
                  <md-table-cell>
                    <HorizontalBarChart
                      :options="getPlaceUses(building, 'options')"
                      :chart-data="getPlaceUses(building, 'data')"
                      :chart-id="`id-uses-chart-${building.id}`"
                      :width="useChartsDimensions.buildingWidth"
                      :height="useChartsDimensions.buildingHeight"
                      :gen-legend="false"/>
                  </md-table-cell>
                </md-table-row>

                <md-table-row
                  class='md-selected'
                  :key="`area-${area.id}`"
                  v-for='area in building.childs'
                  v-if='area.visibleUses === true'>
                  <md-table-cell class="collapse-arrow-column" />
                  <md-table-cell class="name-column">{{ area.name }}</md-table-cell>
                  <md-table-cell>{{ area.function }}</md-table-cell>
                  <md-table-cell>
                    <HorizontalBarChart
                      :options="getPlaceUses(area, 'options')"
                      :chart-data="getPlaceUses(area, 'data')"
                      :chart-id="`id-uses-chart-${area.id}`"
                      :width="useChartsDimensions.areaWidth"
                      :height="useChartsDimensions.areaHeight"
                      :gen-legend="false"/>
                  </md-table-cell>
                </md-table-row>
              </template>
            </md-table>
            <HorizontalBarChart
              :options="usesChartLegendOptions"
              :chart-data="usesChartLegendData"
              :height="50"
              :gen-legend="false"/>
          </md-card-content>
        </md-card>
      </md-app-content>
    </md-app>
    <md-dialog
      :md-fullscreen="false"
      :md-active.sync="placeDetailsCommentDialog.showModal">
      <md-dialog-title
        v-if='placeDetailsCommentDialog.place'>Commentaires {{ placeDetailsCommentDialog.place.name }}</md-dialog-title>
      <md-dialog-content
        v-if='placeDetailsCommentDialog.place'>{{ placeDetailsCommentDialog.place.comment }}</md-dialog-content>
      <md-dialog-actions>
        <md-button
          class="md-primary"
          @click="placeDetailsCommentDialog.showModal = false">
          Fermer
        </md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
import Vue from 'vue'
import session from '../api/session'
import pattern from 'patternomaly'
import BuildingStockHeader from '../components/BuildingStockHeader.vue'
import ValuesDisplayMixin from '../mixins/ValuesDisplayMixin'
import HorizontalBarChart from '../components/HorizontalBarChart.vue'
import BuildingStockUsesPopup from '../components/BuildingStockUsesPopup'
import TagsListWidget from '../components/TagsListWidget.vue'

export default {
  name: 'BuildingStockSiteBuildings',
  mixins: [ValuesDisplayMixin],
  components: { BuildingStockHeader, HorizontalBarChart, TagsListWidget },
  data () {
    return {
      useColorList: ['#03A9F4', '#FF9800', '#4CAF50', '#009688', '#9C27B0', '#795548', '#FFC107', '#E91E63', '#9E9E9E', '#607D8B', '#8BC34A', '#2196F3', '#FF5722', '#673AB7', '#F44336', '#FFEB3B', '#3F51B5', '#CDDC39', '#00BCD4'],

      siteDetails: {},
      siteBuildings: [],
      placeAnnualUsableArea: {},
      placeAnnualConsumptions: {},
      placeAnnualUses: {},
      annualTotalUsableArea: {},
      annualTotalConsumptions: {},

      placeDetailsCommentDialog: {
        showModal: false,
        place: null
      },

      energyList: [],
      usesList: [],
      siteEnergyList: [],
      siteUseList: [],
      siteYearsList: [],

      hasConsumptionsPreviousPagination: false,
      hasConsumptionsNextPagination: false,
      consumptionsPaginationYear: null,

      usesChartOptions: {},
      useChartsDimensions: {
        buildingWidth: 100,
        buildingHeight: 30,
        areaWidth: 100,
        areaHeight: 15
      },

      usesChartLegendOptions: {},
      usesChartLegendData: {},

      hasUsesPreviousPagination: false,
      hasUsesNextPagination: false,
      usesPaginationYear: null
    }
  },
  mounted: function () {
    this.loadApi()
  },
  methods: {
    handleCollapse (building, tableType) {
      if (tableType === 'consumptions') {
        this.$set(building, 'ConsumptionsCollapsed', !building.ConsumptionsCollapsed)
        building.childs.forEach(area => {
          this.$set(area, 'visibleConsumptions', !area.visibleConsumptions)
        })
      } else {
        this.$set(building, 'UsesCollapsed', !building.UsesCollapsed)
        building.childs.forEach(area => {
          this.$set(area, 'visibleUses', !area.visibleUses)
        })
      }
    },
    getPlaceConsumptions (place) {
      return this.placeAnnualConsumptions[this.getPlaceYearKey(place, this.consumptionsPaginationYear)]
    },
    getPlaceUses (place, dataType) {
      const placeUses = this.placeAnnualUses[this.getPlaceYearKey(place, this.usesPaginationYear)]

      if (placeUses) {
        if (dataType === 'options') {
          return this.placeAnnualUses[this.getPlaceYearKey(place, this.usesPaginationYear)].chartOptions
        } else {
          return this.placeAnnualUses[this.getPlaceYearKey(place, this.usesPaginationYear)].dataColletion
        }
      } else {
        return {}
      }
    },
    getPlaceUsableArea (place) {
      return this.placeAnnualUsableArea[this.getPlaceYearKey(place, this.consumptionsPaginationYear)]
    },
    getGoogleMapsUrl (address) {
      return 'https://www.google.fr/maps/search/' + parseFloat(address.latitude) + ',' + parseFloat(address.longitude)
    },
    showPlaceDetailsCommentDialog (place) {
      this.placeDetailsCommentDialog.showModal = true
      this.placeDetailsCommentDialog.place = place
    },
    paginateConsumptionsPrevious () {
      this.consumptionsPaginationYear = this.siteYearsList[this.siteYearsList.indexOf(this.consumptionsPaginationYear) - 1]
      this.hasConsumptionsPreviousPagination = this.siteYearsList.indexOf(this.consumptionsPaginationYear) > 0
      this.hasConsumptionsNextPagination = true
    },
    paginateConsumptionsNext () {
      this.consumptionsPaginationYear = this.siteYearsList[this.siteYearsList.indexOf(this.consumptionsPaginationYear) + 1]
      this.hasConsumptionsPreviousPagination = true
      this.hasConsumptionsNextPagination = this.siteYearsList.indexOf(this.consumptionsPaginationYear) !== this.siteYearsList.length - 1
    },
    paginateUsesPrevious () {
      this.usesPaginationYear = this.siteYearsList[this.siteYearsList.indexOf(this.usesPaginationYear) - 1]
      this.hasUsesPreviousPagination = this.siteYearsList.indexOf(this.usesPaginationYear) > 0
      this.hasUsesNextPagination = true
    },
    paginateUsesNext () {
      this.usesPaginationYear = this.siteYearsList[this.siteYearsList.indexOf(this.usesPaginationYear) + 1]
      this.hasUsesPreviousPagination = true
      this.hasUsesNextPagination = this.siteYearsList.indexOf(this.usesPaginationYear) !== this.siteYearsList.length - 1
    },
    async loadApi () {
      const siteId = this.$route.params.siteId

      this.$store.dispatch('loading/begin_loading')

      const siteDetailsResponse = await session.get(`/api/userdata/sites/${siteId}/`)
      const energiesResponse = await session.get(`/api/parameters/energies/`)
      const usesResponse = await session.get(`/api/parameters/uses/`)
      const siteBuildingsResponse = await session.get(`/api/userdata/sites/${siteId}/buildings/`)

      this.energyList = energiesResponse.data
      this.usesList = usesResponse.data
      this.siteDetails = siteDetailsResponse.data
      this.siteBuildings = siteBuildingsResponse.data
      this.siteEnergyList = []
      this.siteUseList = []
      this.siteYearsList = []
      this.placeAnnualConsumptions = {}
      this.usesChartLegendData = {datasets: []}

      this.energyList.forEach(energy => {
        this.siteBuildings.forEach(building => {
          if (building.childs.length === 1) {
            building.childs = []
          }
          building.annual_consumptions.forEach(consumptionYear => {
            consumptionYear.place_energy_years.forEach(placeEnergyYear => {
              if (placeEnergyYear.energy === energy.id && !this.siteEnergyList.includes(energy)) {
                this.siteEnergyList.push(energy)
              }
            })
          })
        })
      })

      this.usesList.forEach(use => {
        this.siteBuildings.forEach(building => {
          building.annual_consumptions.forEach(consumptionYear => {
            consumptionYear.place_energy_uses.forEach(placeEnergyUse => {
              if (placeEnergyUse.use === use.id && !this.siteUseList.includes(use)) {
                this.siteUseList.push(use)
              }
            })
          })
        })
      })

      this.siteBuildings.forEach(building => {
        building.annual_consumptions.forEach(consumptionYear => {
          if (!this.siteYearsList.includes(consumptionYear.year)) {
            this.siteYearsList.push(consumptionYear.year)
          }
        })
      })

      this.consumptionsPaginationYear = this.siteYearsList[0]
      this.hasConsumptionsNextPagination = this.siteYearsList.length > 1
      this.usesPaginationYear = this.siteYearsList[0]
      this.hasUsesNextPagination = this.siteYearsList.length > 1

      const allPlaces = []
      this.siteBuildings.forEach(building => {
        this.$set(building, 'ConsumptionsCollapsed', false)
        this.$set(building, 'UsesCollapsed', false)
        allPlaces.push(building)
        building.childs.forEach(area => {
          this.$set(area, 'visibleConsumptions', false)
          this.$set(area, 'visibleUses', false)
          allPlaces.push(area)
        })
      })

      this.siteYearsList.forEach(year => {
        let annualTotalUsableArea = 0
        let annualTotalConsumptions = {}

        allPlaces.forEach(place => {
          const placeYearKey = this.getPlaceYearKey(place, year)

          const consumptionYear = place.annual_consumptions.filter(consumptions => {
            return consumptions.year === year
          })[0]

          let consumptions = []
          this.siteEnergyList.forEach(energy => {
            let energyConsumption = 0

            if (energy.slug in annualTotalConsumptions === false) {
              annualTotalConsumptions[energy.slug] = 0
            }

            consumptionYear.place_energy_years.forEach(placeEnergyYear => {
              if (placeEnergyYear.energy === energy.id) {
                energyConsumption += parseFloat(placeEnergyYear.total_energy_consumption)
              }
            })

            consumptions.push(energyConsumption)

            if (place.type === 'building') {
              annualTotalConsumptions[energy.slug] += energyConsumption
            }
          })

          let barThickness = 15
          if (place.type === 'building') {
            annualTotalUsableArea += consumptionYear.usable_area
            barThickness = 30
          }

          let usesChart = {
            chartOptions: {},
            dataColletion: {datasets: []},
            totalConsumptions: 0}

          let useIndex = 0
          this.siteUseList.forEach(use => {
            let useConsumptions = {consumption: 0, estimation: false, use: use}

            consumptionYear.place_energy_uses.forEach(placeEnergyUse => {
              if (placeEnergyUse.use === use.id) {
                useConsumptions.consumption += parseFloat(placeEnergyUse.energy_consumption)
                usesChart.totalConsumptions += parseFloat(placeEnergyUse.energy_consumption)
                if (placeEnergyUse.estimation === true) {
                  useConsumptions.estimation = true
                }
              }
            })

            const color = this.useColorList[useIndex]
            let backgroundColor = color

            if (useConsumptions.estimation === true) {
              backgroundColor = pattern.draw('diagonal-right-left', color)
            }

            let dataset = {
              label: use.label,
              backgroundColor: backgroundColor,
              borderColor: 'white',
              borderWidth: 1,
              barThickness: barThickness,
              yAxisID: 'y-axis-uses',
              data: [{x: useConsumptions.consumption, y: 0, originalData: useConsumptions, place: place}]
            }

            useIndex += 1
            usesChart.dataColletion.datasets.push(dataset)
          })

          usesChart.chartOptions = {
            elements: {
              rectangle: {
                borderWidth: 2
              }
            },
            scales: {
              xAxes: [ {
                stacked: true,
                display: false,
                ticks: {
                  beginAtZero: true,
                  min: 0,
                  max: usesChart.totalConsumptions
                }
              }],
              yAxes: [{
                id: 'y-axis-uses',
                display: false,
                stacked: true
              }]
            },
            responsive: true,
            maintainAspectRatio: false,
            legend: {
              display: false
            },
            title: {
              display: false
            },
            tooltips: this.genUsesChartTooltip(`id-uses-chart-${place.id}-wrapper`)
          }

          this.placeAnnualUsableArea[placeYearKey] = consumptionYear.usable_area
          this.placeAnnualConsumptions[placeYearKey] = consumptions
          this.placeAnnualUses[placeYearKey] = usesChart
        })

        this.annualTotalUsableArea[year] = annualTotalUsableArea
        this.annualTotalConsumptions[year] = []

        this.siteEnergyList.forEach(energy => {
          this.annualTotalConsumptions[year].push(annualTotalConsumptions[energy.slug])
        })
      })

      this.usesChartLegendOptions = {
        scales: {
          xAxes: [ {
            stacked: true,
            display: false
          }],
          yAxes: [{
            id: 'y-axis-uses',
            display: false,
            stacked: true
          }]
        },
        responsive: true,
        legend: {
          display: true,
          fullWidth: true,
          labels: {boxWidth: 35, fontStyle: 'bold'},
          onClick: function () {}
        },
        title: {
          display: false
        }
      }

      this.usesChartLegendData.datasets.push({
        label: 'Donnée importée',
        backgroundColor: 'white',
        borderColor: 'black',
        borderWidth: 1,
        yAxisID: 'y-axis-uses',
        data: []
      })

      this.usesChartLegendData.datasets.push({
        label: 'Estimation planiss\'Immo',
        backgroundColor: pattern.draw('diagonal-right-left', '#9E9E9E'),
        borderColor: 'black',
        borderWidth: 1,
        yAxisID: 'y-axis-uses',
        data: []
      })

      let useIndex = 0
      this.siteUseList.forEach(use => {
        let dataset = {
          label: use.label,
          backgroundColor: this.useColorList[useIndex],
          borderColor: 'white',
          borderWidth: 1,
          yAxisID: 'y-axis-uses',
          data: []
        }
        this.usesChartLegendData.datasets.push(dataset)
        useIndex += 1
      })

      this.$store.dispatch('routing/update_title', 'Site : ' + this.siteDetails.name)
      this.$store.dispatch('routing/update_return_kwargs', {name: 'Building stock sites'})
      this.$store.dispatch('loading/end_loading')
    },
    genUsesChartTooltip (chartId) {
      return {
        enabled: false,
        mode: 'y',
        position: 'average',

        callbacks: {
          label: (tooltipItem, data) => {
            const dataset = data.datasets[tooltipItem.datasetIndex]
            const pointData = dataset.data[tooltipItem.index]
            const originalData = pointData.originalData
            return {originalData: originalData, dataset: dataset, place: pointData.place}
          }
        },
        custom: (tooltipModel) => {
          // Tooltip Element
          let tooltipEl = document.querySelector('#' + chartId + ' #chartjs-tooltip')
          let placeType = null

          // Create element on first render
          if (!tooltipEl) {
            tooltipEl = document.createElement('div')
            tooltipEl.id = 'chartjs-tooltip'
            tooltipEl.innerHTML = '<div id="id_wrapper" ref="tooltipContainer"></div>'
            document.getElementById(chartId).appendChild(tooltipEl)
          }

          // Hide if no tooltip
          if (tooltipModel.opacity === 0) {
            tooltipEl.style.display = 'none'
            return
          }

          // Set caret Position
          tooltipEl.classList.remove('above', 'below', 'no-transform')

          // Set Text
          if (tooltipModel.body) {
            const bodyLines = tooltipModel.body.map(bodyItem => bodyItem.lines)
            let totalConsumption = 0
            let useConsumptions = []

            bodyLines.forEach(consumption => {
              totalConsumption += parseFloat(consumption[0].originalData.consumption)
            })

            bodyLines.forEach(consumption => {
              let useConsumption = consumption[0].originalData
              useConsumption.percentage = useConsumption.consumption / totalConsumption
              useConsumption.backgroundColor = consumption[0].dataset.backgroundColor
              useConsumption.borderColor = consumption[0].dataset.borderColor
              useConsumption.borderWidth = consumption[0].dataset.borderWidth
              useConsumptions.push(useConsumption)
              placeType = consumption[0].place.type
            })

            const Popup = Vue.extend(BuildingStockUsesPopup)
            let instance = new Popup({
              propsData: {
                popupData: {
                  totalConsumption: totalConsumption,
                  useConsumptions: useConsumptions
                }
              }
            })

            instance.$mount()

            const tableRoot = tooltipEl.querySelector('#id_wrapper')
            tableRoot.innerHTML = instance.$el.innerHTML
          }

          let bottom = this.useChartsDimensions.buildingHeight
          if (placeType === 'area') {
            bottom = this.useChartsDimensions.areaHeight
          }

          // Display, position, and set styles for font
          tooltipEl.style.display = 'block'
          tooltipEl.style.position = 'absolute'
          tooltipEl.style.left = '50%'
          tooltipEl.style.marginLeft = '-150px'
          tooltipEl.style.bottom = bottom + 'px'
          tooltipEl.style.width = '330px'
          tooltipEl.style.backgroundColor = 'white'
          tooltipEl.style.fontFamily = tooltipModel._bodyFontFamily
          tooltipEl.style.fontSize = tooltipModel.bodyFontSize + 'px'
          tooltipEl.style.fontStyle = tooltipModel._bodyFontStyle
          tooltipEl.style.padding = '10px'
          tooltipEl.style.borderLeft = '10px solid #86ad19'
          tooltipEl.style.boxShadow = '0 0px 46px -5px #8888888a'
        }
      }
    },
    getPlaceYearKey (place, year) {
      return place.id + '-' + year
    }
  },
  computed: {
    totalUsableArea () {
      return this.annualTotalUsableArea[this.consumptionsPaginationYear]
    },
    totalConsumptions () {
      return this.annualTotalConsumptions[this.consumptionsPaginationYear]
    }
  },
  filters: {
    displayAddress (value) {
      let address = ''

      if (value.address1) {
        address += value.address1 + ' '
      }

      if (value.address2) {
        address += value.address2 + ' '
      }

      if (value.geo_place.zip_code) {
        if (address.length > 0) {
          address += '<br />'
        }
        address += value.geo_place.zip_code + ' '
      }

      if (value.geo_place.name) {
        if (address.length > 0 && !value.geo_place.zip_code) {
          address += '<br />'
        }
        address += value.geo_place.name
      }

      return address
    }
  }
}
</script>

<style lang="scss" scoped>
.page-content {
  overflow: hidden;
  height: auto;
}

.spacer {
  margin-top: 1.5em;
  margin-bottom: 1.5em;
}

.nav__item {
  cursor: pointer;
}

.legend-head >>> .md-table-head-label {
  width: 100%;
}

.area-icon {
  font-size: 12px;
  vertical-align: middle;
  margin-bottom: 2px;
}

.place-coordinates {
  font-size: 10px;
}

.md-table {
  overflow: visible;

  >>> .md-table-content {
    overflow: visible;

    table {
      overflow: visible;
    }
  }
}

.collapse-arrow-column {
  width: 1%;

  >>> .md-table-cell-container,
  >>> .md-table-head-container,
  >>> .md-table-head-label {
    padding: 0;
  }
}

.name-column {
  min-width: 200px;
}

.overflow__visible .md-content{
  overflow: visible !important;
}

</style>



// WEBPACK FOOTER //
// src/views/BuildingStockSiteBuildings.vue